import { CampusWard } from './campus-ward.model';
import { CampusStake } from './campus-stake.model';
import { StakeLeader } from './stake-leader.model';

export class CampusStakeDetails extends CampusStake {
  officeLocation: string;
  interviewTimes: string;
  phone: string;
  email: string;
  modifiedBy: string;
  modifiedOn?: Date;
  president: StakeLeader;
  firstCounselor: StakeLeader;
  secondCounselor: StakeLeader;
  wards: CampusWard[];
}
